export enum AdminRole {
  admin = 'admin',
};

export interface AdminUserData {
  id: string;
  name: string;
  email: string;
  roles: AdminRole[];
}